<template>
  <v-card>
    <v-tabs
      v-model="activeTabLocale"
      grow
      center-active
      class="tab-atendimento"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab.to"
      >
        <v-icon :color="tab.color">
          {{ tab.icon }}
        </v-icon>

        <span
          v-if="tab.title"
          class="ml-2"
        >
          {{ tab.title }}
        </span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTabLocale">
      <v-tab-item
        v-for="(tabItem, index) in tabItems"
        :key="index"
      >
        <component
          :is="tabItem.is"
          :get-tickets="getTickets"
          :get-tickets-and-select-first="getTicketsAndSelectFirst"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiTicketAccount, mdiHistory, mdiCloseCircleOutline, mdiFilePdfBox, mdiClockOutline } from '@mdi/js'
import TicketTab from './ticket-tab/TicketTab.vue'
import AgendamentoTab from './agendamento-tab/AgendamentoTab.vue'
import HistoricoTab from './historico-tab/HistoricoTab.vue'
import GerarPdf from './gerar-pdf/GerarPdf.vue'
import useAtendimentoStore from '@/store/atendimento'
import useAtendimentoTicket from '@/composables/useAtendimentoTicket'

export default {
  emits: ['refetch-slas-contadores'],

  components: {
    TicketTab,
    AgendamentoTab,
    HistoricoTab,
    GerarPdf,
  },

  props: {
    activeTab: {
      type: Number,
      required: false,
      default: 0,
    },
    ticketProtocolo: {
      type: String,
      default: null,
    },
    getTickets: {
      type: Function,
      required: true,
    },
    getTicketsAndSelectFirst: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const { ticketSelecionadoId } = storeToRefs(useAtendimentoStore())
    const { ticketData, getTicketById } = useAtendimentoTicket(ticketSelecionadoId)

    const activeTabLocale = ref(props.activeTab)
    const filaPermiteAgendamento = computed(() => ticketData.value.filaPermiteAgendamento)

    const tabs = computed(() => {
      const arr = [{ icon: mdiTicketAccount, title: `Protocolo: ${props.ticketProtocolo}` }]

      if (filaPermiteAgendamento.value) {
        arr.push({ icon: mdiClockOutline, title: 'Agendamento' })
      }

      arr.push(
        { icon: mdiHistory, title: 'Histórico' },
        { icon: mdiFilePdfBox, title: 'Impressão' },
        { icon: mdiCloseCircleOutline, color: 'error', to: { name: 'front-atendimento' } },
      )

      return arr
    })

    const tabItems = computed(() => {
      const arr = [{ is: 'ticket-tab' }]

      if (filaPermiteAgendamento.value) {
        arr.push({ is: 'agendamento-tab' })
      }

      arr.push(
        { is: 'historico-tab' },
        { is: 'gerar-pdf' },
      )

      return arr
    })

    watch(
      () => ticketSelecionadoId.value,
      v => {
        activeTabLocale.value = props.activeTab || 0

        if (v) {
          getTicketById()
        }
      },
    )

    return {
      activeTabLocale,
      filaPermiteAgendamento,
      tabs,
      tabItems,
    }
  },
}
</script>
